<div
    id="su_one"
    class="liquid-form-area sign-up-area"
    [ngClass]="sucessClassAdd"
>
    <div class="liquid-form-logo">
        <a href="#"><img src="assets/images/logo.png" alt="" /></a>
    </div>
    <div class="liquid-form-heading-text">
        <h4>Welcome to Liquid Insight!</h4>
        <p>Please create an account for our platform</p>
    </div>
    <div class="liquid-form-content">
        <form [formGroup]="signupForm" (ngSubmit)="signup()">
            <!-- single liquid form  -->
            <div class="single-liquid-form">
                <label for="com_name">Company Name</label>
                <input
                    id="com_name"
                    type="text"
                    placeholder="Company Name"
                    formControlName="companyName"
                />
                <div
                    *ngIf="
                        signupForm.controls['companyName'].touched &&
                        !signupForm.controls['companyName'].valid
                    "
                >
                    <span
                        *ngIf="
                            signupForm.controls['companyName'].hasError(
                                'pattern'
                            )
                        "
                    >
                        White space is not allowed
                    </span>
                    <span
                        *ngIf="
                            signupForm.controls['companyName'].hasError(
                                'required'
                            )
                        "
                    >
                        Company name is required
                    </span>
                    <span
                        *ngIf="
                            signupForm.controls['companyName'].hasError(
                                'minlength'
                            )
                        "
                    >
                        Company name must be at minimum 3 characters
                    </span>
                </div>
            </div>

            <!-- single liquid form  -->

            <!-- single liquid form  -->
            <div class="single-liquid-form">
                <div class="parent-single-liquid-form">
                    <div class="child-single-liquid-form">
                        <label for="first_n">First Name</label>
                        <input
                            id="first_n"
                            type="text"
                            placeholder="First Name"
                            formControlName="firstName"
                        />
                        <div
                            *ngIf="
                                signupForm.controls['firstName'].touched &&
                                !signupForm.controls['firstName'].valid
                            "
                        >
                            <span
                                *ngIf="
                                    signupForm.controls['firstName'].hasError(
                                        'required'
                                    )
                                "
                            >
                                First name is required
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls['firstName'].hasError(
                                        'pattern'
                                    )
                                "
                            >
                                White space is not allowed
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls['firstName'].hasError(
                                        'minlength'
                                    )
                                "
                            >
                                First Name must be at minimum 3 characters
                            </span>
                            <span
                                *ngIf="
                                    !signupForm.controls['firstName'].hasError(
                                        'noNumbers'
                                    )
                                "
                            >
                                FirstName should not contain numbers
                            </span>
                        </div>
                    </div>
                    <div class="child-single-liquid-form">
                        <label for="last_n">Last Name</label>
                        <input
                            id="last_n"
                            type="text"
                            placeholder="Last Name"
                            formControlName="lastName"
                        />
                        <div
                            *ngIf="
                                signupForm.controls['lastName'].touched &&
                                !signupForm.controls['lastName'].valid
                            "
                        >
                            <span
                                *ngIf="
                                    signupForm.controls['lastName'].hasError(
                                        'required'
                                    )
                                "
                            >
                                Last name is required
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls['lastName'].hasError(
                                        'pattern'
                                    )
                                "
                            >
                                White space is not allowed
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls['lastName'].hasError(
                                        'minlength'
                                    )
                                "
                            >
                                Last name must be at minimum 3 characters
                            </span>
                            <span
                                *ngIf="
                                    !signupForm.controls['lastName'].hasError(
                                        'noNumbers'
                                    )
                                "
                            >
                                LastName should not contain numbers
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- single liquid form  -->

            <!-- single liquid form  -->
            <div class="single-liquid-form">
                <div class="parent-single-liquid-form">
                    <div class="child-single-liquid-form">
                        <label for="u_name">Username</label>
                        <input
                            id="u_name"
                            type="text"
                            placeholder="Username"
                            formControlName="username"
                        />
                        <div
                            *ngIf="
                                signupForm.controls['username'].touched &&
                                !signupForm.controls['username'].valid
                            "
                        >
                            <span
                                *ngIf="
                                    signupForm.controls['username'].hasError(
                                        'required'
                                    )
                                "
                            >
                                Username is required
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls['username'].hasError(
                                        'pattern'
                                    )
                                "
                            >
                                White space are not allowed
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls['username'].hasError(
                                        'minlength'
                                    )
                                "
                            >
                                Username must be at minimum 3 characters
                            </span>
                        </div>
                    </div>
                    <div class="child-single-liquid-form">
                        <label for="phone">Phone</label>
                        <input
                            id="phone"
                            type="text"
                            placeholder="Phone"
                            formControlName="phoneNumber"
                            #phoneVal
                            (input)="validationCheck(phoneVal.value)"
                            value="{{ phoneNo }}"
                        />
                        <div
                            *ngIf="
                                signupForm.controls['phoneNumber'].touched &&
                                !signupForm.controls['phoneNumber'].valid
                            "
                        >
                            <span
                                *ngIf="
                                    signupForm.controls['phoneNumber'].hasError(
                                        'required'
                                    )
                                "
                            >
                                Phone Number is required
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls['phoneNumber'].hasError(
                                        'minlength'
                                    ) ||
                                    signupForm.controls['phoneNumber'].hasError(
                                        'maxlength'
                                    ) ||
                                    signupForm.controls['phoneNumber'].hasError(
                                        'pattern'
                                    )
                                "
                                >A valid phone number is required
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- single liquid form  -->

            <!-- single liquid form  -->
            <div class="single-liquid-form">
                <label for="com_name_email">Email</label>
                <input
                    id="com_name_email"
                    type="email"
                    placeholder="Email address"
                    formControlName="email"
                />
                <div
                    *ngIf="
                        signupForm.controls['email'].touched &&
                        !signupForm.controls['email'].valid
                    "
                >
                    <span
                        *ngIf="
                            signupForm.controls['email'].hasError('required')
                        "
                    >
                        Email Address is required
                    </span>
                    <span
                        *ngIf="signupForm.controls['email'].hasError('pattern')"
                    >
                        Please Enter valid email address
                    </span>
                    <span
                        *ngIf="signupForm.controls['email'].hasError('email')"
                    >
                        Incorrect email format
                    </span>
                </div>
            </div>
            <!-- single liquid form  -->

            <!-- single liquid form  -->
            <div class="single-liquid-form">
                <div class="parent-single-liquid-form">
                    <div class="child-single-liquid-form">
                        <label for="pass_one">Password</label>
                        <input
                            id="pass_one"
                            type="password"
                            placeholder="Password (min 8 characters)"
                            formControlName="password"
                        />
                        <div
                            *ngIf="
                                signupForm.controls['password'].touched &&
                                !signupForm.controls['password'].valid
                            "
                        >
                            <span
                                *ngIf="
                                    signupForm.controls['password'].hasError(
                                        'required'
                                    )
                                "
                            >
                                Password is required
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls['password'].hasError(
                                        'pattern'
                                    )
                                "
                            >
                                White space is not allowed
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls['password'].hasError(
                                        'minlength'
                                    )
                                "
                            >
                                Password must be at minimum 8 characters
                            </span>
                        </div>
                    </div>
                    <div class="child-single-liquid-form">
                        <label for="pass_two">Confirm Password</label>
                        <input
                            id="pass_two"
                            type="password"
                            placeholder="Confirm Password"
                            formControlName="confirm_password"
                        />
                        <div
                            *ngIf="
                                signupForm.controls['confirm_password']
                                    .touched &&
                                !signupForm.controls['confirm_password'].valid
                            "
                        >
                            <span
                                *ngIf="
                                    signupForm.controls[
                                        'confirm_password'
                                    ].hasError('required')
                                "
                            >
                                Confirm password is required
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls[
                                        'confirm_password'
                                    ].hasError('minlength')
                                "
                            >
                                Confirm password must be at minimum 8 characters
                            </span>
                            <span
                                *ngIf="
                                    signupForm.controls[
                                        'confirm_password'
                                    ].hasError('mustMatch')
                                "
                            >
                                Passwords do not match
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- single liquid form  -->

            <!-- single liquid checkbox -->
            <div class="single-liquid-checkbox form-group">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="liquid-check"
                        formControlName="option1"
                    />
                    <span class="text-error"></span>
                    <label for="liquid-check"
                        >I agree to
                        <a href="https://liquidinsight.net/privacy-policy/"
                            >privacy policy</a
                        >
                        &
                        <a href="https://liquidinsight.net/terms-of-use/"
                            >terms of use</a
                        ></label
                    >
                </div>
            </div>
            <!-- single liquid checkbox -->
            <div class="liquid-login-form-submit">
                <div id="fast-btn">
                    <button
                        type="submit"
                        [disabled]="signupForm.invalid || isLoader"
                    >
                        <i
                            class="fa fa-circle-o-notch fa-spin"
                            *ngIf="isLoader"
                        ></i>
                        Create account
                    </button>
                </div>
                <div class="error-message text-center">
                    <p>{{ errorMsg }}</p>
                </div>
            </div>
        </form>

        <div class="create-account-text">
            <p>
                Already have an account? <a routerLink="/auth/login">Sign In</a>
            </p>
        </div>
    </div>
</div>

<div id="su_two" class="liquid-form-area tabcontent" [ngClass]="sucessClass">
    <div class="liquid-form-logo">
        <a href="#"><img src="assets/images/logo.png" alt="" /></a>
    </div>
    <div class="liquid-form-heading-text">
        <h4>Activate your account!</h4>
        <p>
            Account activation link sent to your email address. Please follow
            the link inside to continue.
        </p>
    </div>
    <div class="back-to-login-link">
        <a [routerLink]="['/auth/login']">Back to Login</a>
    </div>
</div>
